module.exports = function (fox, staticUrl) {
	if (staticUrl) {
		__webpack_public_path__ = __webpack_public_path__.replace(/^.*?\/dist\/+/, staticUrl + (staticUrl.slice(-1) === '/' ? '' : '/'));
	}

	require('../main/__main_entry.tmp.js')(fox);
	require('../affiliate/__main_entry.tmp.js')(fox);

	function getDeps (context) {
		context.keys().forEach((m) => {
			const module = context(m);

			if (typeof module === 'function')
				module(fox);
		});
	}

	require('./stylus/_root-index.styl');
	
	const contexts = [];
	contexts.push(require.context("./css", true, /(\/|\\)(?!_)[\w\.\-\\]+\.css$/));
	contexts.push(require.context("./dependencies", true, /(\/|\\)(?!_)[\w\.\-\\]+\.js$/));
	contexts.push(require.context("./flash", true, /(\/|\\)(?!_)[\w\.\-\\]+\.swf$/));
	contexts.push(require.context("./options", true, /(\/|\\)(?!_)[\w\.\-\\]+\.(opt|js)$/));
	contexts.push(require.context("fox-dynamic-injection!fox-template-loader?interpolate!./templates", true, /(\/|\\)(?!_)[\w\.\-\\]+\.tpl$/));
	contexts.push(require.context("./widget", true, /(\/|\\)(?!_)[\w\.\-\\]+\.js$/));
	contexts.forEach(getDeps);

	fox.RSVP.on('error', error => {
		return console.error && console.error('[Uncaught error in promise]: -> ', error);
	});
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/index.es.js